const forms = document.querySelectorAll(".js-account-registration form");

forms.forEach(form => {
    form.addEventListener('submit', () => {
        const submitButton = form.querySelector("[type='submit']");
        submitButton.classList.add('button__loader');
        submitButton.setAttribute('disabled', '');
    })
});